var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tp-container"},[_c('div',{staticClass:"title"},[_c('div',[_vm._v(_vm._s(_vm.item.name))]),_c('div',[_c('span',{ref:"number"},[_vm._v(_vm._s(_vm.item.number))]),_vm._v(" 张 ")])]),_c('div',{ref:"myChart",staticClass:"tp-chart"})])
}
var staticRenderFns = []

export { render, staticRenderFns }